var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 6.25,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26V6H20.5443C22.0224 6 23.2552 6.2181 24.2427 6.6543C25.2303 7.0905 25.9726 7.69596 26.4696 8.4707C26.9667 9.23893 27.2152 10.1244 27.2152 11.127C27.2152 11.9082 27.0582 12.5951 26.7443 13.1875C26.4304 13.7734 25.9987 14.2552 25.4494 14.6328C24.9065 15.0039 24.2852 15.2676 23.5854 15.4238V15.6191C24.3506 15.6517 25.0668 15.8665 25.7339 16.2637C26.4075 16.6608 26.9536 17.2174 27.3722 17.9336C27.7907 18.6432 28 19.4896 28 20.4727C28 21.5339 27.7351 22.4811 27.2054 23.3145C26.6822 24.1413 25.9072 24.7956 24.8804 25.2773C23.8536 25.7591 22.5881 26 21.0839 26H12.5ZM16.7478 22.543H20.2108C21.3945 22.543 22.2578 22.3184 22.8006 21.8691C23.3435 21.4134 23.6149 20.8079 23.6149 20.0527C23.6149 19.4994 23.4808 19.0111 23.2127 18.5879C22.9445 18.1647 22.5619 17.8327 22.0649 17.5918C21.5744 17.3509 20.989 17.2305 20.3089 17.2305H16.7478V22.543ZM16.7478 14.3691H19.8968C20.4789 14.3691 20.9956 14.2682 21.4468 14.0664C21.9046 13.8581 22.2643 13.5651 22.526 13.1875C22.7941 12.8099 22.9282 12.3574 22.9282 11.8301C22.9282 11.1074 22.6698 10.5247 22.1532 10.082C21.643 9.63932 20.9171 9.41797 19.9753 9.41797H16.7478V14.3691Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 6H12.9592V11.4456H12.9999V6ZM12.9999 13.52C12.966 13.4915 12.9331 13.4613 12.9013 13.4294L7.66498 8.19311L6.19311 9.66498L11.4294 14.9013C12.0365 15.5084 12.0365 16.4916 11.4294 17.0987L6.19311 22.335L7.66498 23.8069L12.9013 18.5706C12.9331 18.5387 12.966 18.5085 12.9999 18.48V13.52ZM12.9999 20.5535H12.9592V26H12.9999V20.5535ZM9.50094 17.0408H4V14.9592H9.50094V17.0408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.d26e8bcbb56dd044983fb4bf69bf5ae6.svg";
export { ForwardRef as ReactComponent };